import { FC, ComponentProps } from "react";
import styled from "styled-components";

import Box, { BoxProps } from "../../components/particles/Box";
import constants from "../../components/_globalStyles/constants";

export const BoxBorderedStyled: FC<BoxProps> = styled(Box)`
max-width: ${constants.GRID_UNIT * 128};
margin: 0 auto;
padding-top: ${constants.GRID_UNIT * 3}px;
padding-bottom: ${constants.GRID_UNIT * 3}px;
border: 1px solid #00000014;
border-radius: 32px;
`

